/**
 * Hook para gerenciar campos personalizados
 */

import { useState, useEffect } from "react";
import type { CustomField } from "../types";
import { getPublicCustomFields } from "../../../services/public";

interface UseCustomFieldsProps {
  slug: string | null;
  selectedServiceId?: string;
}

export function useCustomFields({ slug, selectedServiceId }: UseCustomFieldsProps) {
  const [customFields, setCustomFields] = useState<CustomField[]>([]);
  const [customValues, setCustomValues] = useState<Record<string, any>>({});

  useEffect(() => {
    if (!slug) return;

    getPublicCustomFields(slug, selectedServiceId || undefined)
      .then((fields) => {
        setCustomFields(fields || []);

        const initValues: Record<string, any> = {};
        (fields || []).forEach((f) => {
          if (f.type === "checkbox") initValues[f.id] = false;
          else initValues[f.id] = "";
        });
        setCustomValues(initValues);
      })
      .catch(() => setCustomFields([]));
  }, [slug, selectedServiceId]);

  const validateCustomFields = (): string | null => {
    for (const f of customFields) {
      if (!f.required) continue;

      const val = customValues[f.id];
      if (
        val === undefined ||
        val === null ||
        val === "" ||
        (f.type === "checkbox" && val !== true)
      ) {
        return `Preencha o campo obrigatório: ${f.label}`;
      }
    }
    return null;
  };

  const clearCustomValues = () => {
    const cleared: Record<string, any> = {};
    customFields.forEach((f) => (cleared[f.id] = f.type === "checkbox" ? false : ""));
    setCustomValues(cleared);
  };

  return {
    customFields,
    customValues,
    setCustomValues,
    validateCustomFields,
    clearCustomValues,
  };
}
